module.exports = __webpack_public_path__ + "img/email-pending.4ae971cf.png";